










































































































































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import DemographicsUtility from '@utils/DemographicsUtility'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventHero from '@ui/Event/EventHero'
import TagBar from '@ui/TagBar'
import EditorContent from '@components/EditorContent'
import AudienceListingBrandPartners from './AudienceListingBrandPartners'
import AudienceListingServices from './AudienceListingServices'
import AudienceListingPhysicalSigns from './AudienceListingPhysicalSigns'
import AudienceListingPersona from './AudienceListingPersona'
import AudienceListingMap from './AudienceListingMap'
import PricingModel from '@services/PricingModel'
import Indicators from '@ui/Indicators'
import SuperNotes from '@modules/ui/notes/SuperNotes'

settings =
  name: 'AudienceListingDetail'

  vue:
    props: ['audienceListing', 'campaign', 'cart', 'activationPlan', 'nearbyPOIs', 'hideClose', 'options', 'actions']

    components: {
      LoadingIndicator,
      EventHero,
      TagBar,
      EditorContent,
      AudienceListingBrandPartners,
      AudienceListingServices,
      AudienceListingPhysicalSigns,
      AudienceListingPersona,
      AudienceListingMap,
      Indicators,
      SuperNotes,
    }

    computed:
      member: -> @$store.member
      target: -> @getPageSession "matches:#{@campaign?.id}"

      showPartnershipPricing: ->
        !!@options?.showPartnershipPricing

      title: ->
        TitlePatternUtility.formatListingTitle @audienceListing

      canFavorite: ->
        @member.id && @actions.favoriteAudienceListingTrigger && @actions.unfavoriteAudienceListingTrigger

      isFavorited: -> false
      isRecommended: -> false
      isRecentlyPublished: -> !!@audienceListing.published_at

      quantities: ->
        value = []
        if @activationPlan
          value.push { label: 'Reach', value: @activationPlan.reach } if @activationPlan.reach > 0
          value.push { label: 'Sampling Capacity', value: @activationPlan.capacity } if @activationPlan.capacity > 0
        else
          reach = parseInt(@audienceListing.reach || '0')
          capacity = parseInt(@audienceListing.sampling_capacity || '0')
          value.push { label: 'Reach', value: reach } if reach > 0
          value.push { label: 'Sampling Capacity', value: capacity } if capacity > 0

        if @currentMemberIsSuperUser()
          if @audienceListing.occupancy_count?.delivery_points
            { delivery_label, delivery_points } = @audienceListing.occupancy_count
            value.push { label: delivery_label, value: delivery_points }

        value

      venueOccupancy: ->
        { resident_count, room_count } = @audienceListing.occupancy_count || {}
        items = []
        items.push "#{resident_count} Residencies" if resident_count
        items.push "#{room_count} Rooms" if room_count
        items
      venueStorageCapacity: ->
        { cold_storage_count, frozen_storage_capacity } = @audienceListing.storage_capacity || {}
        items = []
        items.push "#{cold_storage_count} Cold Storage" if cold_storage_count
        items.push "#{frozen_storage_capacity} Frozen Storage Capacity" if frozen_storage_capacity
        items

      listingTypes: -> @audienceListing?.types || []
      listingCategories: -> @audienceListing.category_tags.map((type) => @$options.filters.formatListingCategory(type))
      eventActivities: -> @audienceListing.activity_tags.map((activity) => @$options.filters.formatTitle(activity))

      displayPhysicalSigns: ->
        @audienceListing.physical_signs?.enabled

      audienceTags: -> @audienceListing.audience_tags || []
      demographics: -> @audienceListing.demographics || {}
      hasAudienceInsights: -> @audienceTags.length > 0 || !@isEmptyValue(@demographics) || !@isEmptyValue(@audienceListing.persona_profile)

      eventSpaces: -> Object.values(@audienceListing?.spaces || {})
      showSamplingPricing: -> !!@options?.showSamplingPricing
      bookedSamplingPrice: -> @options?.bookedSamplingPrice
      priceForVideoWall: -> PricingModel.priceForVideoWall @audienceListing, @marketplace.standard_pricing_table

      partnerRequirements: -> @audienceListing.partner_requirements || []
      hasPartnerRequirements: -> !!@partnerRequirements.length
      hasPartnerRestrictions: ->
        { drink = [], food = [], onsite = [] } = @audienceListing.partner_restrictions || {}
        !![...drink, ...food, ...onsite].length
      hasSpecialTerms: -> !!@audienceListing.special_terms?.length

      sponsorSet: -> @audienceListing.sponsor_set || []
      catex: -> Object.values(@audienceListing.catex || {}).filter((catex) => catex.prohibited or @categoryIsExclusive(catex))
      audienceListingReviews: -> @audienceListing.reviews || []

      secretBrandDomains: -> Object.keys(@marketplace?.secret_brands || {})

      tagOptionsForListingTypes: ->
        {
          bar: {
            theme: 'secondary',
            max: 12,
          },
          tag: {
            theme: 'secondary',
            format: 'formatListingType',
            maxLength: 12,
          }
        }

      tagOptionsForVenueTags: ->
        {
          bar: {
            theme: 'secondary',
            max: 12,
          },
          tag: {
            theme: 'secondary',
            format: 'formatListingType',
            maxLength: 12,
          }
        }

      demographicsSkeleton: ->
        DemographicsUtility.getAll()

      indicators: ->
        @audienceListing.indicators || {}

    methods:
      hiClose: ->
        if @actions?.close?
          @actions.close()
        else 
          @$router.push(@$route.path.split('/listings/')[0])

      hiFavoriteAudienceListingTrigger: -> @actions.favoriteAudienceListingTrigger @audienceListing
      hiUnfavoriteAudienceListingTrigger: -> @actions.unfavoriteAudienceListingTrigger @audienceListing
      hiAddSuperNote: -> @actions.addSuperNote @audienceListing.new_super_notes[0]

      imageForSpace: (space) ->
        image = space.image
        image ||= space.images?[0]
        image ||= @placeholderImageForSpace space
        image
      placeholderImageForSpace: (space) ->
        spaceType = "booth_#{space.size}" if space.type is 'onsite_space'
        spaceType ||= space.type
        "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{spaceType}.png"
      spaceTypeIsProductSampling: (space) -> 'product_sampling' is space.type
      foodDistribuitionPrice: -> parseFloat(@pricingTable.food_distribution?.price_in_cents) / 100 || 0
      drinkDistribuitionPrice: -> parseFloat(@pricingTable.drink_distribution?.price_in_cents) / 100 || 0
      promoDistribuitionPrice: -> parseFloat(@pricingTable.promo_distribution?.price_in_cents) / 100 || 0
      onSiteSpaceOptions: -> ['roaming', 'booth_10x10', 'booth_10x20', 'booth_20x40', 'booth_40x60']
      spaceTypeIsOnsiteSpace: (space) -> space.type in @onSiteSpaceOptions
      categoryIsExclusive: (catex) -> !!catex.sponsors?.length
      spaceNameFor: (space) ->
        { formatShortSpaceType } = @$options.filters
        name = formatShortSpaceType(space.type)
        name += " #{space.size}" if space.type is 'onsite_space'
        name
      spacePriceFor: (space) -> parseInt(space.price_in_cents || '0') / 100

      isMeSponsoring: (sponsor) ->
        { formatDomain } = @$options.filters
        isSameCampaignDomain = formatDomain(sponsor.domain) is formatDomain(@campaign?.brand_info.domain)
        isSameSponsorDomain = formatDomain(sponsor.domain) is formatDomain(@member?.sponsor?.domain)
        isSameCampaignDomain || isSameSponsorDomain
      isSecretBrand: (sponsor) ->
        { formatDomain } = @$options.filters
        formatDomain(sponsor.domain) in @secretBrandDomains

      displayMaxPalletForSpace: (space) ->
        (@spaceTypeIsOnsiteSpace(space) || @spaceTypeIsProductSampling(space)) and space.max_pallets_count > 0

      hiAddBookingSpace: (space, pricingModel) ->
        @actions.addBookingSpace space, pricingModel
        @$router.replace { query: { ...@$route.query, segment: space.segment } }
      hiRemoveBookingSpace: (spaceName) ->
        @actions.removeBookingSpace spaceName

      hiNavToIndicatorResource: (indicator) ->
        { id, resource, query } = indicator.context.link
        query = new URLSearchParams(query).toString() if query
        
        resourceRoutes =
          supplier: 'suppliers'
          venue: 'venues'
          audience_creative: 'experiences'
          audience_availability: 'availabilities'

        url = "/#{resourceRoutes[resource]}/#{id}/edit"
        url += "?#{query}" if query
        window.open url, url

      convertDemographicValueToPercentage: (value) ->
        (value || 0) * 100

      formatDemographicsGroup: (key) ->
        DemographicsUtility.labelForGroup key

      formatAddress: (location) ->
        { street, city, state, country, zip } = location
        address = [street, city, state, country].filter(Boolean).join(', ')
        address = "#{address} #{zip}" if zip
        address

export default VueOptions.vue settings
